export default "/kiban/_next/static/images/initialCost-f7eb11c0ebce27d0bc100c23a7c920b8.svg";